import React, { useEffect, useRef } from 'react';
import { injectIntl } from 'react-intl';
import Icon from '@UI/Icon';

// Provide better code readability.
// eslint-disable-next-line object-curly-newline
function Modal({ intl, title, children, onClose, footer, id }) {
  const modalRef = useRef();

  useEffect(() => {
    const { current } = modalRef;
    // Not a native component but class, can't import it right away.
    // eslint-disable-next-line global-require
    const { Modal: ModalJS } = require('@ffw/randstad-local-orbit/js/components/modal');
    const ModalJSInit = new ModalJS(current);
    ModalJSInit.openModal(false);

    let timer;

    const cleanUp = () => {
      document.querySelector('html').classList.remove('modal-open');
    };

    const closingModal = () => {
      timer = setTimeout(() => {
        cleanUp();
        onClose();
      }, 350);
    };

    // Handle X button event.
    current.addEventListener('modal-close', closingModal);

    return () => {
      cleanUp();
      if (current) {
        current.removeEventListener('modal-close', closingModal);
      }
      clearTimeout(timer);
    };
  }, [onClose]);

  return (
    <div className="modal" ref={modalRef} data-rs-modal={id} role="dialog" aria-hidden="true">
      <div className="modal__dialog bg-variant-brand-tertiary" role="dialog" aria-modal="true" aria-labelledby="#" data-rs-modal-dialog="">
        <div className="modal__header" data-rs-modal-header="">
          <h3 className="modal__title">{title}</h3>
          <button type="button" className="button--icon-only modal__close" data-rs-modal-close-trigger="" aria-label={intl.formatMessage({ id: 'Close' })}>
            <Icon type="close" className="icon icon--inline hidden--from-l fill-brand--blue icon--alternative" />
            <Icon type="close-30" className="icon icon--l icon--inline hidden--until-l icon--alternative" />
          </button>
        </div>
        <div className="modal__main" data-rs-modal-main="">{children}</div>
        {footer
          && <div className="modal__footer" data-rs-modal-footer="">{footer}</div>}
      </div>
    </div>
  );
}

export default injectIntl(Modal);
